import { TakeoverProps } from '@palmetto/dsm-components';
import React, { useEffect } from 'react';
import { useUpdateConnectedAccountStatus } from '../../../../api/connected-accounts/useUpdateConnectedAccountStatus';
import { ArcadiaConfig } from '../../../../config';
import { FlowStepProps, trackEvent, useComponentTracking, useTranslation } from '@helios/frontend-core';


import { ArcadiaIframeConnectionStatus } from './UtilityConnectionCompleted';

export interface UtilityArcadiaIframeStepProps extends FlowStepProps {
  propertyId: string;
  providerId: string;
  connectedAccountId?: string;
  setHeaderDetails?: (details: Partial<TakeoverProps>) => void;
  onDismiss?: () => void;
  iframeUrl: string;
  eventTrackingName: string;
  headingKey?: string;
}

const localePrefix = 'utilityProvider.steps.utilityLogin';

const UtilityArcadiaIframeStep: React.FC<UtilityArcadiaIframeStepProps> = ({
  setStep,
  propertyId,
  providerId,
  connectedAccountId,
  setHeaderDetails,
  onDismiss,
  iframeUrl,
  eventTrackingName,
  headingKey,
}) => {
  const trackingId = `takeover-arcadia-iframe-step-${eventTrackingName}`;
  const { t } = useTranslation();
  const { updateStatus } = useUpdateConnectedAccountStatus();

  useComponentTracking(trackingId);

  useEffect(() => {
    const handleMessage = async (event: MessageEvent) => {
      if (event.origin !== ArcadiaConfig.connectUrl) return;
      if (event.data?.type !== 'onEnd') return;
      const iframeStatus: ArcadiaIframeConnectionStatus = event?.data?.payload?.status;
      if (connectedAccountId && iframeStatus) {
        await updateStatus(connectedAccountId, 'inProgress');
      }

      trackEvent(eventTrackingName, {
        propertyId,
        providerId,
        status: iframeStatus,
      });
      setStep('utility-connect-completed', { connectionStatus: iframeStatus, propertyId });
    };
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [propertyId, providerId, connectedAccountId, setStep, eventTrackingName, updateStatus]);

  useEffect(() => {
    if (setHeaderDetails && headingKey && onDismiss) {
      setHeaderDetails({
        heading: t(headingKey),
        topNavProps: {
          leftButton: {
            onClick: onDismiss,
            text: t('common.cancel'),
          },
        },
      });
    }
  }, [setHeaderDetails, headingKey, onDismiss, t]);

  return (
    <div>
      <iframe
        style={{ border: 'none' }}
        height="660px"
        width="100%"
        title={t(`${localePrefix}.heading`)}
        src={
          iframeUrl?.includes('origin=')
            ? iframeUrl
            : `${iframeUrl}${iframeUrl?.includes('?') ? '&' : '?'}origin=${encodeURIComponent(
                window.location.origin,
              )}`
        }
      />
    </div>
  );
};

export default UtilityArcadiaIframeStep;
